/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta, IRespuestaPaginada } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import IDocumentoDetalleCompuesto from 'Infotrack@Modelos/smartStock/documentosDetalle/entidades/documentoDetalleCompuesto';
import { negocio } from '../../conexiones';
import IAlmacenamiento from './entidades/almacenamiento';
import IAlmacenamientoFiltro from './entidades/almacenamientoFiltro';

export default class ModeloAlmacenamiento {
    public ConsultarListaAlmacenamientoFiltro({ paginador, almacenamiento }: IAlmacenamientoFiltro) {
        return manejadorRest<IRespuestaPaginada<IAlmacenamiento>>(
            () => negocio.post('Almacenamiento/ConsultarListaAlmacenamientoFiltro', { paginador, almacenamiento }),
            true
        );
    }

    public ModificarFlujoEtapaAlmacenamiento(almacenamiento: IAlmacenamiento) {
        return manejadorRest<IRespuesta<IAlmacenamiento>>(
            () => negocio.put('Almacenamiento/ModificarFlujoEtapaAlmacenamiento', almacenamiento),
            true
        );
    }

    public AnularAlmacenamiento(almacenamiento: IAlmacenamiento) {
        return manejadorRest<IRespuesta<IAlmacenamiento>>(
            () => negocio.put('Almacenamiento/AnularAlmacenamiento', almacenamiento),
            true
        );
    }

    public EditarAlmacenamientoDetallesParcial(documentoDetalle: IDocumentoDetalleCompuesto) {
        return manejadorRest<IRespuesta<IAlmacenamiento>>(
            () => negocio.put('Almacenamiento/EditarAlmacenamientoDetallesParcial', documentoDetalle),
            true
        );
    }

    public EditarAlmacenamientoDetallesTotal(documentoDetalle: IDocumentoDetalleCompuesto) {
        return manejadorRest<IRespuesta<IAlmacenamiento>>(
            () => negocio.put('Almacenamiento/EditarAlmacenamientoDetallesTotal', documentoDetalle),
            true
        );
    }
}
